export const controlChars = [
    "===", // new page
    "---", // new grid row/ start a grid
    "-->", // end a grid
    "|", // split page
    "[]", // empty cell/placeholder
    "^^^", /// sticky grid  
    "vvv", /// sticky footer
] as const;

export const codeBlockControlChar = "```" /// code block

export type CodeBlockType = "```"


export type ControlCharsType = typeof controlChars[number];

export type ControlCharsObjectType = {
    [k in typeof controlChars[number] | CodeBlockType]: {
        controlChar: typeof controlChars[number] | CodeBlockType;
        help: string;
    };
};

export const controlCharsObject: ControlCharsObjectType = {
    "===": {
        controlChar: "===",
        help: "Creates a new page",
    },
    "|": {
        controlChar: "|",
        help: "Split The Page in Two",
    },
    "---": {
        controlChar: "---",
        help: "Create a new row for a grid or start a grid",
    },

    "-->": {
        controlChar: "-->",
        help: "End a grid",
    },
    "[]": {
        controlChar: "[]",
        help: "Create an empty cell in a gird",
    },
    "^^^": {
        controlChar: "^^^",
        help: "Create a grid that sticks to the top of the page"
    },
    "vvv": {
        controlChar: "vvv",
        help: "Create a grid that sticks to the bottom of the page"
    },
    "```": {
        controlChar: "```",
        help: "Add code or latex. Add the type after e.g. ```tsx"
    }

};


export function isControlChar(arg: unknown) {
    // @ts-expect-error: I think typescript types Array.includes too tightly to be useful
    if (controlChars.includes(arg)) {
        return true;
    }
    return false;
}